export const fontFamily = {
  primary: 'Poppins, sans-serif',
};

export const fontWeight = {
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
};
